<template>
  <div
    contenteditable="true"
    @paste="handlePaste"
    v-html="innerText"
    @input="changeText"
    @blur="blurHandler"
  ></div>
</template>

<script>
  export default {
    props: ['value'],
    data() {
      return {
        innerText: this.value,
        placeholder: "请输入内容..."
      };
    },
    methods: {
      changeText() {
        this.$emit('changeText', this.$el.innerHTML);
      },
      blurHandler() {
        this.$emit('blur');
      },
      handlePaste(e) {
        e.preventDefault();
        let text = '';
        let clp = (e.originalEvent || e).clipboardData;
        if (clp && clp.getData) {
          text = clp.getData('text/plain') || '';
        } else if (window.clipboardData && window.clipboardData.getData) {
          text = window.clipboardData.getData('text') || '';
        }
        if (text !== '') {
          if (document.queryCommandSupported('insertText')) {
            document.execCommand('insertText', false, text);
          } else {
            if (window.getSelection) {
              const newNode = document.createElement('span');
              newNode.innerHTML = text;
              window.getSelection().getRangeAt(0).insertNode(newNode);
            } else {
              document.selection.createRange().pasteHTML(text);
            }
          }
        }
      }
    },
    watch: {
      value(newValue) {
        if (this.innerText !== newValue) {
          this.innerText = newValue;
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/EditableDiv.vue